/// <reference path="../../typings/browser.d.ts" />

namespace Application.Common {
   'use strict';

   const MIN_PORT: number = 0;
   const MAX_PORT: number = 65535;
   const MAC_DEVICES: string[] = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
   const WINDOWS_DEVICES: string[] = ['Windows', 'Win32', 'WinCE'];
   const LINUX_DEVICES: string[] = ['Linux', 'Linux aarch64', 'Linux armv5tejl', 'Linux armv6l', 'Linux armv7l',
       'Linux i686', 'Linux i686 on x86_64', 'Linux i686 X11', 'Linux ppc64', 'Linux x86_64', 'Linux x86_64 X11'];
   const MAC_DEVICE: string = 'MAC';
   const WINDOWS_DEVICE: string = 'WINDOWS';
   const LINUX_DEVICE: string = 'LINUX';
   const UNKNOWN_DEVICE: string = 'UNKNOWN';


    /**
     * Utils class, set of utility functions
     */
    export class Utils {

        public static MAX_INTEGER: number = 9007199254740992;

        public static objectsDifference (a: Object[], b: Object[]): Object[] {
            let diff: Object[] = a.filter((aElem: Object) => {
                return b.every((bElem: Object) => {
                    return !angular.equals(aElem, bElem);
                });
            });

            return diff;
        };

        public static range(max: number): number[] {
            return new Array(max);
        }

        public static rangeForNgRepeat(max: number): number[] {
            let range: number[] = [];
            for (let i: number = 0; i < max; i++) {
                range.push(i);
            }
            return range;
        }

        public static randPosition(): number {
            let val: number = Math.random();
            if (val > 0.5) {
                return -1 * Math.round(val * 200);
            } else {
                return Math.round(val * 200);
            }
        }

        public static randomNumber(max: number): number {
            return Math.round(Math.random() * max);
        }

        public static escapeHtml(text: string): string {
            if (text)
                return text
                    .replace(/&/g, "&amp;")
                    .replace(/</g, "&lt;")
                    .replace(/>/g, "&gt;")
                    .replace(/"/g, "&quot;")
                    .replace(/'/g, "&#039;");
            else
                return undefined;
        }

        /**
         * Usage:
         * data = {'param1': 'value1', 'param2': 'Jetson'};
         * result =  "param1=value1&param2=value2";
         */
        public static encodeQueryData(data: Object): string {
            let ret: Array<string> = [];
            if (data) {
                for (let d in data) {
                    if (d) {
                        ret.push(encodeURIComponent(d) + "=" + encodeURIComponent(data[d]));
                    }

                }
            }
            return ret.join("&");
        }

        /** clone an object
         * Be careful as this is not doing a complete deep copy, this only clone plainObjects.
         * Custom objects still need to be deep copy manually
        **/
        public static clone<T>(oldObject: T): T {
            // deep copy
            return jQuery.extend(true, {}, oldObject);
        }

        public static strIdFromHref(href: string): string {
            return href.substr(href.lastIndexOf('/') + 1);
        }

        public static idFromHref(href: string): number {
            return parseInt(Utils.strIdFromHref(href), 10);
        }

        public static hasGuiInterface(href: string): boolean {
            let id: number = this.idFromHref(href);
            let res: boolean;
            if (id === 1 || id === 2 || id === 7) {
                res = true;
            } else {
                res = false;
            }
            return res;
        }

        public static getSimplifiedHrefFromString(href: string): string {
            let splitResult: string[] = href.split("/");
            let splitLength: number = splitResult.length;
            let simplifiedHref: string = "/" + splitResult[splitLength - 2] + "/" + splitResult[splitLength - 1];
            return simplifiedHref;
        }

        public static getCurrentTimestamp(): number {
            return Math.floor(Date.now() / 1000);
        }

        public static alertOnInfo(mssg: string, position?: string): void {
            let template: string = "<div class='uk-text-center'>" + mssg + "</div>";
            this.alert(template, "info", position);
        }

        public static alertOnSuccess(mssg: string, position?: string): void {
            let template: string = "<div class='uk-text-center'>" + mssg + "</div>";
            this.alert(template, "success", position);
        }

        public static alertOnWarning(mssg: string, position?: string): void {
            let template: string = "<div class='uk-text-center'>" + mssg + "</div>";
            this.alert(template, "warning", position);
        }

        public static alertOnError(mssg: string, position?: string): void {
            let template: string = "<div class='uk-text-center'>" + mssg + "</div>";
            this.alert(template, "danger", position);
        }

        public static stickyAlertModal(mssg: string, status: string): void {
            let template: string = "<div class='uk-text-center'>" + mssg + "</div>";
            UIkit.notify(template, {timeout: 0, status: status, pos: "top-center"});
        }

        public static alertModal(mssg: string, status: string): void {
            let template: string = "<div class='uk-text-center'>" + mssg + "</div>";
            UIkit.notify(template, {timeout: 2000, status: status, pos: "top-center"});
        }

        public static stickyAlert(mssg: string, status: string, timeout: number): void {
            let template: string = "<div class='uk-text-center'>" + mssg + "</div>";
            timeout = timeout && timeout > 0 ? timeout * 1000 : 0;
            UIkit.notify(template, {timeout: timeout, status: status, pos: "bottom-center"});
        }

        public static stickyAlertPos(mssg: string, status: string, timeout: number, position: string): void {
            let template: string = "<div class='uk-text-center'>" + mssg + "</div>";
            timeout = timeout && timeout > 0 ? timeout * 1000 : 0;
            UIkit.notify(template, {timeout: timeout, status: status, pos: position});
        }

        public static stickyAlertUpdate(mssg: string): void {
            let template: string = "<div class='uk-text-center'>" + mssg + "</div>";
            $('.uk-notify').children('.uk-notify-message').children('div').html(template);
        }

        public static closeStickyAlerts(): void {
            let notificationDiv: JQuery = $('.uk-notify');
            notificationDiv.children().remove();
        }

        /**
         * Validates if a comma-separated port list is valid
         * Ranges (10-50) are valid
         */
        public static validatePortList(ports: string): boolean {
            return (new RegExp("^(?:(?:^|[-,])(\\s*)(?:[1-9][0-9]{0,3}|[1-5][0-9]{4}|6(?:[0-4][0-9]{3}|5" +
                "(?:[0-4][0-9]{2}|5(?:[0-2][0-9]|3[0-5]))))(\\s*))+$")).test(ports);
        }

        public static validateIPAddress(ipAddress: string): boolean {
            return (new RegExp("^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9]" +
                "[0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$")).test(ipAddress);
        }

        /**
         * Format: 192.168.0.0/24
         */
        public static validateIPAddressRange(ipAddress: string): boolean {
            return (new RegExp("^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9]" +
                "[0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)" +
                "(\/[0-9]|\/[1-2][0-9]|\/3[0-2])?$")).test(ipAddress);
        }

        /**
         * Parses a list of ports in string format. Examples:
         * 1-140
         * 2,3,4,5
         * 8080
         * 900-910,906
         */
        public static parsePortList(ports: string): number[] {
            let portList: number[] = [];

            if (ports.length > 0) {
                for (let portSet of ports.split(",")) {
                    if (portSet.indexOf("-") > -1) {
                        // range
                        let range: number[] = Utils.parsePortRange(portSet);
                        if (range !== undefined) {
                            for (let port of range) {
                                if (portList.indexOf(port) === -1) {
                                    portList.push(port);
                                }
                            }
                        } else {
                            return undefined;
                        }
                    } else {
                        // single port
                        let port: number = Utils.validatePort(portSet);
                        if (port !== undefined)
                            if (portList.indexOf(port) === -1) {
                                portList.push(port);
                            }
                        else
                            return undefined;
                    }
                }
            }
            return portList;
        }

        /**
         * Validates the length of a numeric number input (num) to be between a range of values.
         * If MAX is undefined, we presume that the value need to be exactly MIN characters length.
         */
        public static lengthRange(num: number, min: number, max?: number): boolean {
            if (!num || !min) {
                return true;
            } else if (!max) {
                return num.toString().length === min;
            } else {
                return num.toString().length >= min && num.toString().length <= max;
            }
        }

        /**
         * Returns the size of an associative array
         */
        public static sizeOf(obj: Object): number {
            let size: number = 0;
            let key: string;

            for (key in obj) {
                if (obj.hasOwnProperty(key))
                    size++;
            }

            return size;
        }

        /**
         * get the secondary block id from redundant encoder group, for example
         * if group is 5-4 and current block is 5, return 4
         * if group is 5-4 and current block is 4, return 5
         */
        public static getRedundantIdFromEncoderGroup(block: Models.IBlockComplete){
            let redundancyIds: Array<String> = block.config.redundancyGroup.redundancyIds.split("-");
            let secondaryTakeId = Number(redundancyIds[1]);
            if (block.id === Number(redundancyIds[1])) {
                secondaryTakeId = Number(redundancyIds[0]);
            }
            return secondaryTakeId;
        }

        public static delay = async (ms: number) => new Promise(res => setTimeout(res, ms));

        public static humanReadableBytesAsObject(bytes: number, decimals?: number): Models.IDataRemaining {
            let result: Models.IDataRemaining = { value: 0, unit: 'B'};
            if (bytes < 1024) {
                result.value = bytes;
                return result;
            }
            let k: number = 1024;
            let dm: number = decimals !== undefined ? decimals : 2;
            let sizes: string[] = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
            let i: number = Math.floor(Math.log(bytes) / Math.log(k));
            result.value = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));
            result.unit = sizes[i];
            return result;
        }

        public static orderArrayByKey(element: any[], key: any){
            return element.sort((a: any, b: any) => a[key].localeCompare(b[key]));
        }

        public static humanReadableBytes(bytes: number, decimals?: number): string {
            let k: number = 1024;
            let dm: number = decimals !== undefined ? decimals : 2;
            if (bytes < k)
                return bytes.toFixed(dm) + ' B';

            let sizes: string[] = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
            let i: number = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
        }

        public static kibiHumanReadableBits(bits: number, decimals?: number): string {
            let k: number = 1000;
            let dm: number = decimals !== undefined ? decimals : 2;
            if (bits < k)
                return bits.toFixed(dm) + ' bps';

            let sizes: string[] = ['Bps', 'Kbps', 'Mbps', 'Gbps', 'Tbps', 'Pbps', 'Ebps', 'Zbps', 'Ybps'];
            let i: number = Math.floor(Math.log(bits) / Math.log(k));
            return parseFloat((bits / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
        }

        public static kibiHumanReadableBitsAsObject(bits: number, decimals?: number): Models.IDataRemaining {
            let dm: number = decimals !== undefined ? decimals : 1;
            let res: string = this.kibiHumanReadableBits(bits, dm);

            let value: number = parseFloat(parseFloat(res.substr(0, res.indexOf(" "))).toFixed(1));
            let unit: string = res.substr(res.indexOf(" ") + 1);
            return {value: value, unit: unit};
        }

        public static bitRateToHumanReadable(bits: number): string {
            let kbits: number = bits / 1000; // kibits
            if (kbits < 100)
                return kbits.toFixed(1) + ' kbps';
            else
                return kbits.toFixed(0) + ' kbps';
        }


        // verify iccid using the last digit as check digit using the Lhun algorithm (https://en.wikipedia.org/wiki/Luhn_algorithm)
        public static checkIccid(iccid: string): boolean {
            let helper: number[] = new Array();
            let sum: number = 0;
            for (let i: number = 0; i < iccid.length; i++)
                helper.push(parseInt(iccid.substr(i, 1), 10));
            for (let i: number = helper.length - 2; i >= 0; i -= 2) {
                helper[i] *= 2;
                if (helper[i] >= 10)
                    helper[i] = parseInt(('' + helper[i])[0], 10) + parseInt(('' + helper[i])[1], 10);
            }
            for (let i: number = 0; i < helper.length; i++)
                sum += helper[i];
            return (sum % 10) === 0 ? true : false;
        }

        /**
         * Dates
         */

        /**
         * Return a date as YYYYMMDDHHmmss
         */
        public static dateToString(input: Date, endOfTheDay?: boolean, toUTC?: boolean): string {
            let year: string = toUTC ? input.getUTCFullYear().toString() :  input.getFullYear().toString();
            let month: number = toUTC ? (input.getUTCMonth() + 1) : (input.getMonth() + 1);
            let day: number = toUTC ? input.getUTCDate() : input.getDate();
            let hours: number = toUTC ? input.getUTCHours() : input.getHours();
            let minutes: number = toUTC ? input.getUTCMinutes() : input.getMinutes();
            let seconds: number = toUTC ? input.getUTCSeconds() : input.getSeconds();

            let monthStr: string;
            monthStr = (month < 10) ? '0' + month : month.toString();

            let dayStr: string;
            dayStr = (day < 10) ? '0' + day : day.toString();

            if (!endOfTheDay) {
                let hoursStr: string;
                hoursStr = (hours < 10) ? '0' + hours : hours.toString();

                let minutesStr: string;
                minutesStr = (minutes < 10) ? '0' + minutes : minutes.toString();

                let secondsStr: string;
                secondsStr = (seconds < 10) ? '0' + seconds : seconds.toString();

                return year + monthStr + dayStr + hoursStr + minutesStr + secondsStr;
            } else {
                return year + monthStr + dayStr + '235959';
            }

        }

        public static epochSecondsToMilliseconds(date: number): number {
            return date * 1000;
        }

        public static epochToHHMMSS(secs: number, tz?: string): string {
            return Utils.epochMilliToHHMMSS(this.epochSecondsToMilliseconds(secs), tz);
        }

        public static epochMilliToHHMMSS(millisecs: number, tz?: string): string {
            let date: Date = new Date(0);
            date.setUTCMilliseconds(millisecs);
            if (!tz) tz = "Etc/GMT";
            let tzDate: moment.Moment = moment(date).tz(tz);
            return tzDate.format('HH:mm:ss');
        }

        public static epochMilliToFormat(millisecs: number, format: string, tz?: string): string {
            let date: Date = new Date(0);
            date.setUTCMilliseconds(millisecs);
            if (!tz) tz = "Etc/GMT";
            let tzDate: moment.Moment = moment(date).tz(tz);
            return tzDate.format(format);
        }


        public static setCssClassAttribute(className: string, attribute: string, value: string ): void {
            let cssMainContainer: JQuery = $('#css-modifier-container');
            if (cssMainContainer.length === 0) {
                cssMainContainer = $('<div id="css-modifier-container"></div>');
                cssMainContainer.hide();
                cssMainContainer.appendTo($('body'));
            }

            // and we need one div for each class`
            let classContainer: JQuery = cssMainContainer.find( `div[data-class="${className + attribute}"]` );
            if (classContainer.length === 0) {
                classContainer = $(`<div data-class="${className + attribute}"></div>`);
                classContainer.appendTo(cssMainContainer);
            }

            // append additional style
            classContainer.html(`<style>${className} { ${attribute}: ${value} }</style>`);
        }

        public static deleteCssClassAttributeMatching( className: string ): void {
            $( `#css-modifier-container div[data-class*="${className}"]` ).remove();

        }


        public static secsToHHMMSS(secs: number): string {
            let hours: number = Math.floor(secs / (60 * 60));
            let divisorForMinutes: number = secs % (60 * 60);
            let minutes: number = Math.floor(divisorForMinutes / 60);

            let divisorForSeconds: number = divisorForMinutes % 60;
            let seconds: number = Math.ceil(divisorForSeconds);

            if (hours === 0 && minutes === 0) {
                return seconds + "s";
            } else if (hours === 0) {
                return minutes + "min " + seconds + "s";
            } else {
                return hours + "h " + minutes + "min " + seconds + "s";
            }
        }

        public static secsToPrettyHHMM(secs: number): string {
            let hours: number = Math.floor(secs / (60 * 60));
            let divisorForMinutes: number = secs % (60 * 60);
            let minutes: number = Math.floor(divisorForMinutes / 60);
            let result: string = "";
            if (minutes !== 0) {
                result = minutes + "min";
            }
            if (hours !== 0) {
                result = hours + "h " + result;
            }
            return result.trim();
        }

        public static secsToSimRemainingTime(secs: number): string {
            if (Math.floor(secs / (60 * 60 * 6)) > 0) return "more than 6 hours";
            else if (Math.floor(secs / (60 * 60 * 5)) > 0) return "more than 5 hours";
            else if (Math.floor(secs / (60 * 60 * 4)) > 0) return "more than 4 hours";
            else if (Math.floor(secs / (60 * 60 * 3)) > 0) return "more than 3 hours";
            else if (Math.floor(secs / (60 * 60 * 2)) > 0) return "more than 2 hours";
            else return this.secsToHHMMSS(secs);
        }

        public static round(input: number, decimals: number): number {
            const modifier: number = Math.pow(10, decimals);
            return Math.round(input * modifier) / modifier;
        }

        public static getCookieExpirationDate(): string {
            let now: Date = new Date();
            return new Date(now.setTime(now.getTime() + (30 * 24 * 60 * 60 * 1000))).toUTCString();
        }

        public static startsWith(str: string, value: string): boolean {
            return str.indexOf(value) === 0;
        }

        public static endsWith(str: string, value: string): boolean {
            return str.indexOf(value) === (str.length - value.length);
        }

        public static validatePortNum(port: number): boolean {
            return (port >= MIN_PORT && port <= MAX_PORT);
        }

        public static guid(): string {
            return this.s4() + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + this.s4() + this.s4();
        }

        public static exists(element: any): boolean { //tslint:disable-line
            return !(element === null || element === undefined); //tslint:disable-line
        }

        public static isNumeric(element: any): boolean { // tslint:disable-line
            return !jQuery.isArray(element) && (element - parseFloat(element) + 1) >= 0;
        }

        public static getCIDRFromSubnetMask(ip: string, subnetMask: string): string {
            let	subnetMaskNum: number, prefix: number = 0, newPrefix: number = 0, prefixSize: number;

            let d: string[] = subnetMask.split( '.' );
            subnetMaskNum = ((((((+d[0]) * 256) + (+d[1])) * 256) + (+d[2])) * 256) + (+d[3]);

            for (prefixSize = 0; prefixSize < 32; prefixSize++) {
                newPrefix = (prefix + (1 << ( 32 - (prefixSize + 1)))) >>> 0; //tslint:disable-line
            
                if( ((subnetMaskNum & newPrefix) >>> 0) !== newPrefix) { //tslint:disable-line
                    break;
                }
            
                prefix = newPrefix;
            }
            
            return ip + "/" + prefixSize.toString();
        }

        public static hoursToDays(hours: number): string {
            if (hours >= 24) {
                return `${Math.floor(hours / 24)}d ${hours % 24 > 0 ? Math.round(hours % 24 * 100) / 100 + 'h' : ''}`;
            } else {
                return `${Math.round(hours * 100) / 100}h`;
            }
        }

        public static isInArray(value: string, array: string[]): boolean {
            return array.indexOf(value) > -1;
        }

        public static findIndex<T>(predicate: (t: T) => boolean, array: T[]): number {
            let found: number = -1;
            if (array) {
                array.forEach((t: T, index: number) => {
                    if (predicate(t)) {
                        found = index;
                    }
                });
            }
            return found;
        }

        public static getMobileDevicesTypeNames(): string[] {
            return ['FLEX-Expert', 'FLEX-WIO', 'FLEX-Agile'];
        }

        public static getUrlParameters(href: string): string {
            const index: number = href.indexOf('?');
            return index > -1
                ? href.substr(index)
                : '';
        }

        public static sortStrings(strings: string[]): string[] {
            return strings.sort((a: string, b: string) => a.localeCompare(b));
        }

        /**
         * Method to normalize the platform in order to being able to know if it's MAC, WIN or LINUX
         * @return the device platform or unknown
         */
        public static getDevicePlatform(): string {
            const platform: string = navigator.platform;
            if (MAC_DEVICES.indexOf(platform) > -1) {
                return MAC_DEVICE;
            }
            if (WINDOWS_DEVICES.indexOf(platform) > -1) {
                return WINDOWS_DEVICE;
            }
            if (LINUX_DEVICES.indexOf(platform) > -1) {
                return LINUX_DEVICE;
            }
            return UNKNOWN_DEVICE;
        }

        /**
         * Helper method to parse a query string an get the parameters in a map
         * @param queryString string to be parsed
         * @return Map with the parsed values or empty object if the query string is NULL, undefined or empty
         */
        public static parseQueryString(queryString: string): { [key: string]: string; } {
            const params: { [key: string]: string; } = {};

            if (!queryString || queryString.length === 0) {
                return params;
            }

            const queries: string[] = queryString.split("&");

            queries.forEach((indexQuery: string) => {
                const indexPair: string[] = indexQuery.split("=");
                // Needed to avoid empty keys
                if (indexPair[0].length > 0 ) {
                    const queryKey: string = decodeURIComponent(indexPair[0]);
                    params[queryKey] = decodeURIComponent(indexPair.length > 1 ? indexPair[1] : '');
                }
            });

            return params;
        }

        /**
         * Generates a command able to open an encrypted SRT streaming in VLC,
         * it will point to the default VLC installation path, otherwise it has to be changed manually afterwards
         *
         * @param srtUrl url with format 'srt://ip:port'
         * @param params map which may contain the parameters needed to stream the SRT
         * @param devicePlatform needed to set the default VLC path
         * @return string with the command to be run or undefined if we don't have the parameters needed
         */
        public static generateVLCScript(srtUrl: string, params: { [key: string]: string; }, devicePlatform: string): string {
            const passKey: string = 'passphrase';
            const keyLentKey: string = 'pbkeylen';

            // If the elements needed fit the initial requirements
            if (srtUrl && srtUrl.length > 0 &&
                params && passKey in params && keyLentKey in params &&
                params[passKey] && params[passKey].length > 0 && params[keyLentKey] && params[keyLentKey].length > 0 &&
                devicePlatform && devicePlatform.length > 0) {

                let pathToVLC: string = '';
                let secondaryPathToVLC: string = '';
                const passAndUrl: string = `--passphrase ${params[passKey]} --key-length ${params[keyLentKey]} ${srtUrl}`;
                switch (devicePlatform) {
                    case MAC_DEVICE:
                        pathToVLC = '/Applications/VLC.app/Contents/MacOS/VLC';
                        return `${pathToVLC} ${passAndUrl}`;
                    case WINDOWS_DEVICE:
                        pathToVLC = '"C:\\Program Files\\VideoLAN\\VLC\\vlc.exe"';
                        secondaryPathToVLC = '"C:\\Program Files (x86)\\VideoLAN\\VLC\\vlc.exe"';
                        return `${pathToVLC} ${passAndUrl} || ${secondaryPathToVLC} ${passAndUrl}`;
                    case LINUX_DEVICE:
                        return `/usr/bin/vlc ${passAndUrl} || /etc/vlc ${passAndUrl} || /usr/lib/vlc ${passAndUrl} || ` +
                               `/usr/bin/X11/vlc ${passAndUrl} || /usr/share/vlc ${passAndUrl}`;
                    default:
                        pathToVLC = 'insert_here_the_VLC_path';
                        return `${pathToVLC} ${passAndUrl}`;
                }
            }

            return undefined;
        }

        /**
         * Method to copy in the clipboard any passed text
         * @param textToCopy the text to be copied
         */
        public static copyToClipboard(textToCopy: string): void {
            if (textToCopy && textToCopy.length > 0) {
                const textToCopyId: string = 'text_to_copy_id';
                // Create an input to copy the string array inside it
                const vlcElement: HTMLTextAreaElement = document.createElement("textarea");
                // Add it to the document
                document.body.appendChild(vlcElement);
                // Set its ID
                vlcElement.setAttribute("id", textToCopyId);
                // Set the text content
                document.getElementById(textToCopyId).textContent = textToCopy;
                // Select it
                vlcElement.select();
                // Copy its contents
                document.execCommand("copy");
                // Remove it as its not needed anymore
                document.body.removeChild(vlcElement);
            }
        }

        /**
         * @param srtUrl: original srt url
         * @return url as a string with custom srtflex protocol format
         */
        public static generateSrtURLWithFlexProtocol(srtUrl: string): string {
            let srtUrlOut: string = '';
            if (srtUrl && srtUrl.length > 0) {
                const splittedUrl: string[] = srtUrl.split('?');
                const newRootUrl: string = splittedUrl[0].replace('srt','srtflex');
                const paramsUrl: { [key: string]: string; } = this.parseQueryString(splittedUrl[1]);

                const passKey: string = 'passphrase';
                const keyLentKey: string = 'pbkeylen';
                const keyLentKeyNewUrl: string = 'key-length';

                if (newRootUrl !== undefined && paramsUrl !== undefined && (passKey in paramsUrl)
                    && (keyLentKey in paramsUrl) && paramsUrl[passKey] && paramsUrl[passKey].length > 0 && paramsUrl[keyLentKey]
                    && paramsUrl[keyLentKey].length > 0) {
                    srtUrlOut = `${newRootUrl}?${passKey}=${paramsUrl[passKey]}&${keyLentKeyNewUrl}=${paramsUrl[keyLentKey]}`;
                }
            }
            return srtUrlOut;
        }

        public static getUrlParam(url: string, param: string): string {
            let urlParams =  url.split("?")[1];
            let paramsJson = JSON.parse('{"' + urlParams.replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');
            return paramsJson[param];
        }

        /**
         * If the provided condition is true, there will be a redirection to the new route.
         * No need to put the "/#!/" before the route.
         * @param condition condition for redirection
         * @param newRoute new route for redirection
         */
        public static redirectToCorrectRoute(condition: boolean, newRoute: string): void {
            if(condition)
                window.location.href = '/#!/' + newRoute;
        }
        
        /**
         * If provided file name exists, it will return the file name without the extension, the given input otherwise.
         * @param fileName File name with extension.
         * @returns the file name without the extension, the given input otherwise.
         */
        public static getFileBaseName(fileName: string): string {
            return this.exists(fileName) ? fileName.substr(0, fileName.lastIndexOf(".")) : fileName;
        }


        private static s4(): string {
            return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
        }

        private static alert(mssg: string, type: string, position?: string): void {
            UIkit.notify(mssg, { timeout: 2000, status: type, pos: position ? position : "bottom-left" });
        }

        private static validatePort(port: string): number {
            let portNumber: number = parseInt(port, 10);

            if (!isNaN(portNumber) && portNumber >= MIN_PORT && portNumber <= MAX_PORT)
                return portNumber;
            else
                return undefined;
        }

        private static parsePortRange(portSet: string): number[] {
            let lowPort: number = parseInt(portSet.split('-')[0], 10);
            let highPort: number = parseInt(portSet.split('-')[1], 10);

            if (lowPort === undefined || highPort === undefined ||
                lowPort > highPort || lowPort < MIN_PORT ||
                highPort > MAX_PORT)
                return undefined;
            else {
                let portList: number[] = [];
                for (let i: number = lowPort; i <= highPort; i++)
                    portList.push(i);

                return portList;
            }
        }

        /**
         * Generates the download of a CSV file with the provided data
         * @param csvRows array with all the csv lines
         * @param fileName name of the file that will be downloaded WITHOUT extension
         * @param allowDuplicates if set to true will keep the duplicates in the csvRows, it's false by default
         */
        public static generateCsvDownload(csvRows: string[], fileName: string, allowDuplicates: boolean = false) {
            let csvData: string[] = [...csvRows];

            if(!allowDuplicates) {
                const csvRowsSet: Set<string> = new Set();
                csvData = [];
                csvRows.forEach(csvRow => csvRowsSet.add(csvRow));
                csvRowsSet.forEach(row => csvData.push(row));
            }
            
            // this method to download the file might have size limitations 
            const a = document.createElement('a');
            a.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csvData.join('\n'));
            a.download = fileName + '.csv';
            document.body.appendChild(a);
            a.click(); 
        }

        public static regExpEscape(literalString: string) {
            return literalString ? literalString.replace(/[-[\]{}()*+!<=:?.\/\\^$|#\s,]/g, '\\$&') : literalString;
        }

        /**
         * Creates a boolean promise and returns it resolved with the received value
         *
         * @param q q service
         * @param value promise value
         * @return resolved promise
         */
        public static getBoolPromise(q: ng.IQService, value: boolean) {
            const d = q.defer<boolean>();
            d.resolve(value);
            return d.promise;
        }
    }
}
